import './styles.scss';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StepIndicator from './StepIndicator';

const propTypes = {
  smallTitle: PropTypes.string,
  title: PropTypes.string,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string,
      icon: PropTypes.string
    })
  ),
  showSteps: PropTypes.bool
};

const defaultProps = {
  showSteps: false
};

class Head extends Component {
  render() {
    const { smallTitle, title, steps, showSteps } = this.props;

    return (
      <div className="head-wrapper row">
        <div className="head-wrapper__top col-sm-12">
          <div className="head-wrapper__text-wrapper">
            <div className="head-wrapper__small">{smallTitle}</div>
            <h1 className="head-wrapper__title">{title}</h1>
          </div>
        </div>
        {showSteps && <StepIndicator steps={steps} />}
      </div>
    );
  }
}

Head.propTypes = propTypes;
Head.defaultProps = defaultProps;

export default Head;
